import { render } from "./Body.vue?vue&type=template&id=78b4dc50"
import script from "./Body.vue?vue&type=script&lang=js"
export * from "./Body.vue?vue&type=script&lang=js"

import exportComponent from "/Volumes/Workspace/Projekty/ewidencjaenergii-pl/pde/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__